var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',{staticClass:"t-flag-icon",class:[
    { 't-flag-icon--rounded': _vm.rounded } ],attrs:{"icon":_vm.flagCode}})}
var staticRenderFns = []

export { render, staticRenderFns }